<template>
    <div>
        <div class="ban">
            <div class="ban_text">
                <p class="p1">ABOUT US</p>
                <p class="p2">关于我们</p>
            </div>
        </div>
        <div class="center">
            <p class="label">企业简介</p>
            <p class="desc">
                北京中采智信信息技术有限公司，为解决传统采购模式的痛点，以河北建工集团的物资集中采购业务为基础，自主研发搭建物资集采综合服务平台—中采智信网(http://www.cnzhongcai.com)，以及建采得一网（www.jiancaideyi.com）。采购范围囊括建筑施工中所有物资采购以及专业、劳务分承包等综合招标。经过多年实际业务运行，目前平台采购量累计280亿元，合作供应商达1.6万余家。
            </p>
            <p class="desc">
                建采得一网的目标是打造一套独特的智慧供应链管理平台，基于区块链技术对建材贸易全链路数据进行上链存证，营造“链上可信”的平台环境，链接外部金融机构，助力供应商在线融资，同时在一定程度上帮助招标方缓解资金压力。
            </p>
            <div style="height:60px"></div>
            <!-- <p class="desc">为进一步确保物资采购的公开、透明，建工
                物流子公司中采智信自主搭建物资集采电商平台——中 采智信网。平台涵盖招采
                中心、中采指数、建材超市等多项功能板块，不断推进平台管理与招标工作的网
                络化、自动化，提升采购工作效率，确保招标过程的公平、公正与公开。</p>
            <p class="desc">
                在做
                好集团内部服务的前提下，公司运用社会化发展理念开展中采智信网平台对外推
                广工作，逐步 扩大平台辐射力与影响力，积极创建阳光采购环境，打造全国最具
                影响力的智慧采购平台，争做采购领 域诚信领跑者。
            </p> -->
            <!-- <div class="pic"><img src="../assets/platform_company.png" alt=""></div> -->
        </div>
        <div class="contract">
            <div class="center">
                <p class="t">联系方式</p>
                <div class="d">
                    <p>地址：</p>
                    <p>河北省石家庄市桥西区西二环与新华路交叉口西行200米</p>
                </div>
                <div class="d">
                    <p>电话：</p>
                    <p>010-57026742</p>
                </div>
                <div class="d">
                    <p>邮箱：</p>
                    <p>liushuang@tongxiaozixun.com</p>
                </div>
                <div class="map">
                    <amap :zoom.sync="map.zoom" :center.sync="map.center">
                    </amap>
                </div>
            </div>

        </div>

    </div>
</template>
<script>
import Amap from "@amap/amap-vue/lib/amap";//地图控件

import {
    getNewsDetailById
} from "@/api/api";
export default {
    components: { Amap },
    data() {
        return {
            con: {},
            id: '',
            map: {
                room: 14,
                center: [114.44, 38.03]
            }
        };
    },
    mounted() {
        this.id = this.$route.query.id
        // this.getBodyContent()
    },
    methods: {
        getBodyContent() {
            getNewsDetailById(this.id).then(res => {
                console.log(res)
                if (res.code == 1000) {
                    this.con = res.data
                } else {

                }
            })
        }
    }
}
</script>
<style scoped lang="scss">
.ban {
    background: url(../assets/banner_new.png) no-repeat center center;
    background-size: cover;
    height: 430px;
    overflow: hidden;
    // margin-top: 110px;

    .ban_text {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .p1 {
            font-size: 50px;
            font-weight: bold;
            color: #FFFFFF;
        }

        .p2 {
            font-size: 30px;
            color: #FFFFFF;
        }
    }
}

@media screen and (max-width: 750px) {
    .ban {
        height: 346px;
        margin-top: 206px;
    }
}

.label {
    font-size: 50px;
    color: #233B83;
    text-align: left;
    margin-bottom: 50px;
    margin-top: 70px;
    font-family: 'CustomFont', sans-serif;


}

.desc {
    font-size: 24px;
    line-height: 44px;
    color: #3D3D3D;
    text-indent: 2em;
    text-align: left;
}

.pic {
    width: 628px;
    height: 433px;
    margin: 30px auto 65px;

    img {
        width: 100%;
        height: 100%;
    }
}

.contract {
    width: 100%;
    background: #F1F3F7;
    padding: 70px 0 80px 0;

    .t {
        font-size: 50px;
        color: #233B83;
        text-align: left;
        margin-bottom: 27px;
        font-family: 'CustomFont', sans-serif;

    }

    .d {
        display: flex;
        line-height: 45px;
    }

    .d>p:first-child {
        font-weight: 400;
        font-size: 26px;
        color: #3D3D3D;
        width: 100px;
    }

    .d>p:last-child {
        font-weight: 400;
        font-size: 24px;
        color: #808080;
        text-align: left;
    }

    .map {
        width: 100%;
        height: 561px;
        border: 1px solid #F1F3F7;
        margin-top: 50px;
    }
}

@media screen and (max-width: 750px) {
    .center {
        width: 80%;
    }

    .contract {}
}
</style>